import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "q-pb-md q-pt-sm text-body1" }
const _hoisted_2 = ["innerHTML"]

import { format, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import SfxTextarea from "src/components/input/SfxTextarea.vue"
import { computed, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogInput',
  props: {
  modelValue: {
    type: Boolean,
    default: undefined,
  },

  title: {
    type: String,
  },

  content: {
    type: String,
  },

  html: {
    type: Boolean,
    default: false,
  },

  persistent: {
    type: Boolean,
    default: false,
  },

  inputRequired: {
    type: Boolean,
    default: false,
  },

  inputInitial: {
    type: String,
  },

  inputTextArea: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
  },

  classes: {
    type: String,
  },

  titleClass: {
    type: String,
  },

  width: {
    type: Number,
  },

  confirmButtonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_confirm"))
    },
  },

  confirmButtonClasses: {
    type: String,
  },

  rejectButtonText: {
    type: String,
    default: () => {
      const { t } = useI18n()
      return format.capitalize(t("sfxButtons.btn_ok"))
    },
  },

  rejectButtonClasses: {
    type: String,
  },
},
  emits: [...useDialogPluginComponent.emits, "update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const model = computed({
  get() {
    return props.modelValue
  },

  set(value) {
    return emit("update:modelValue", value)
  },
})

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
const input = ref(props.inputInitial || "")
const inputRef = ref<typeof SfxInput | typeof SfxTextarea | null>(null)

const dialogWidthStyle = computed(() => {
  return props.width ? `width: ${props.width}px;` : ""
})

//endregion

//region Function

function handleDialogOk() {
  if (props.inputRequired) {
    // Allow only if the input is valid
    if (inputRef.value?.validate()) onDialogOK(input.value)
  } else {
    onDialogOK(input.value)
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    persistent: props.persistent,
    modelValue: model.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((model).value = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["q-dialog-plugin", props.classes]),
        style: _normalizeStyle(dialogWidthStyle.value)
      }, {
        default: _withCtx(() => [
          (props.title)
            ? (_openBlock(), _createBlock(_component_q_card_section, {
                key: 0,
                class: _normalizeClass([props.titleClass, "q-dialog__title text-h3"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title), 1)
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (props.html)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: props.content
                    }, null, 8, _hoisted_2))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(props.content), 1)
                    ], 64))
              ]),
              (props.inputTextArea === false)
                ? (_openBlock(), _createBlock(SfxInput, {
                    key: 0,
                    ref_key: "inputRef",
                    ref: inputRef,
                    class: "q-pt-sm",
                    modelValue: input.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
                    required: props.inputRequired,
                    label: props.label,
                    onKeyup: _withKeys(handleDialogOk, ["enter"]),
                    autofocus: "",
                    "hide-bottom-space": ""
                  }, null, 8, ["modelValue", "required", "label"]))
                : _createCommentVNode("", true),
              (props.inputTextArea === true)
                ? (_openBlock(), _createBlock(SfxTextarea, {
                    key: 1,
                    ref_key: "inputRef",
                    ref: inputRef,
                    class: "q-pt-sm",
                    modelValue: input.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((input).value = $event)),
                    required: props.inputRequired,
                    label: props.label,
                    autofocus: "",
                    "hide-bottom-space": ""
                  }, null, 8, ["modelValue", "required", "label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-px-md q-pb-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: props.rejectButtonText,
                class: _normalizeClass(["col q-mr-sm", __props.rejectButtonClasses])
              }, null, 8, ["onClick", "label", "class"]),
              _createVNode(SfxBtn, {
                onClick: handleDialogOk,
                label: props.confirmButtonText,
                class: _normalizeClass(["col", __props.confirmButtonClasses])
              }, null, 8, ["label", "class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class", "style"])
    ]),
    _: 1
  }, 8, ["onHide", "persistent", "modelValue"]))
}
}

})